import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLoginPage() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm">
        <div className="flex items-center gap-2 justify-center mb-6">
          <span className="bg-navy text-white rounded-xl p-2">
            <Truck className="w-5 h-5" />
          </span>
          <span className="font-heading font-extrabold text-lg text-navy">Express Delivery</span>
        </div>
        <h1 className="font-heading font-bold text-xl text-navy text-center mb-6">Espace administrateur</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            data-testid="admin-login-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="rounded-xl h-11"
          />
          <Input
            data-testid="admin-login-password"
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="rounded-xl h-11"
          />
          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-orange hover:bg-orange-hover text-white rounded-full font-semibold h-11"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null} Se connecter
          </Button>
        </form>
      </div>
    </div>
  );
}
